<app-sidenav [navMode]="'scenario'" *ngIf="hasPass"></app-sidenav>

<div class="container-fluid login">
  <div class="row">
    <div class="col-lg-4 offset-lg-4 col-sm-6 offset-sm-3">
      <div class="card bg-white shadow px-3 pb-3">
        <div class="card-body">
          <h3 class="card-title mb-3">Multi Factor Authentication</h3>
          <div *ngIf="isLoading" class="text-center">
            <app-loading-spinner></app-loading-spinner>
          </div>
          <div *ngIf="hasPass">
            <p class="lead">
              Your account is protected multi factor authentication.
            </p>

            <!--button 
            class="btn btn-primary w-100 btn-block shadow-primary">Reset</button-->
          </div>

          <div *ngIf="!hasPass">
            <p class="lead">
              Protect your account with multi factor authentication.
            </p>

            <div *ngIf="!hasSeed">
              <p>
                Once you have installed your app, please scan the following QR
                code with your Authenticator app
              </p>
              <div class="text-center m-3"><img src="{{ qrImg }}" /></div>
              <p class="text-center">
                Or enter the code <strong>{{ secret }}</strong>
              </p>
              <hr />
              <div class="text-center">
                <button
                  class="btn btn-primary btn-block btn-lg"
                  (click)="onContinue()"
                >
                  Continue
                </button>
              </div>
            </div>
            <div *ngIf="hasSeed">
              <div class="row">
                <div class="col">
                  <div class="alert alert-danger" *ngIf="error">
                    <p>{{ error }}</p>
                  </div>
                  <form
                    #authForm="ngForm"
                    (ngSubmit)="onSubmit(authForm)"
                    *ngIf="!isLoading"
                  >
                    <p>Please enter the code from the authenticator app</p>

                    <div class="text-center mb-4">
                      <ng-otp-input
                      #ngOtpInput
                        (onInputChange)="onOtpChange($event)"
                        [config]="{ length: 6 }"
                      ></ng-otp-input>
                    </div>

                    <button
                      type="submit"
                      [disabled]="theCode && theCode.length!=6"
                      class="btn btn-primary w-100 btn-block shadow-primary"
                    >
                      Validate
                    </button>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <button (click)="onBack()" class="btn btn-link mt-5" *ngIf="hasSeed">
        Back
      </button>
    </div>
  </div>
</div>

<app-footer *ngIf="!hasPass"></app-footer>